
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1507|6747|8905)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
